import { GetManyV2Dto } from '@fleet-beat/core';

export interface NotificationItemDataDto {
  vehicleId?: string | null;
  name?: string | null;
  vin?: string | null;
  [key: string]: unknown;
}

export interface NotificationItemDto {
  id: string;
  type: string;
  data: NotificationItemDataDto;
}

export interface NotificationMetadataDto {
  state?: 'entered' | 'exited' | string;
  geofenceId?: string;
  geofenceName?: string;
  geofenceType?: 'risk-zone' | 'restricted-zone' | 'fuel-station' | 'terminal' | 'rest-area' | 'uncategorised' | string;
  geofenceShape?: 'polygon' | 'circle' | string;
  [key: string]: unknown;
}

export interface NotificationDto {
  id: string;
  createdAt: string;
  status: 'unread' | 'read' | string;
  level: 'info' | 'warning' | 'error' | string;
  type: string;
  metadata: NotificationMetadataDto;
  item: NotificationItemDto;
}
export interface GetManyNotificationsDto extends GetManyV2Dto {
  status?: 'unread' | 'read';
}
